  u<template>
 <div class="login-page">
   <div class="login-wrapper mx-auto mt-sm-5 py-5 p-sm-4">
     <div class="row">
       <div class="col-12 col-md-6">
         <div class="text-center font-weight-light pb-3 py-sm-3">
           <h4>Вход в личный кабинет</h4>
         </div>
         <form class="form" @submit.prevent="login">

           <div class="row contact-block">
             <div class="col-10">
               <div class="form-group">
                  <input v-mask="['+7 (###) ###-##-##', '+7 (###) ###-##-##']" class="form-control"
                            required id="username" v-model="loginInputs.username"
                            @focusin="InputFocusIn('username')"
                            @focusout="InputFocusOut('username')"/>
                  <label for="username">Ваш номер телефона</label>
               </div>
             </div>
             <div class="col-2 pt-4">
               <v-popover offset="26" placement="left">
                 <font-awesome-icon class="tooltip-target b3" :icon="['fa', 'info-circle']" />
                 <template slot="popover">
                   Номер телефона, который указывался Вами при регистрации и на который
                   должно приходить напоминание об оплате.
                 </template>
               </v-popover>
             </div>
           </div>

           <div class="row contact-block">
             <div class="col-10">
               <div class="form-group">
                  <input class="form-control" :type="show === true ? 'text' : 'password'"
                         required id="psw" v-model="loginInputs.password"
                         @focusin="InputFocusIn('psw')"
                         @focusout="InputFocusOut('psw')"/>
                  <label for="psw">Пароль</label>
                  <font-awesome-icon class="show-icon" v-if="show"
                                     @click="show = !show" :icon="['fas', 'eye-slash']" />
                  <font-awesome-icon class="hide-icon" v-else
                                     @click="show = !show" :icon="['fas', 'eye']" />
               </div>
             </div>
             <div class="col-2 pt-4">
               <v-popover offset="26" placement="left">
                 <font-awesome-icon :icon="['fa', 'info-circle']" />
                 <template slot="popover">
                   Пароль приходил по СМС на телефон, который указывался Вами при регистрации
                   и на который должно приходить напоминание об оплате.
                 </template>
               </v-popover>
             </div>
           </div>

           <div v-if="error" class="error">
             <div v-for="e in error" :key="e">
               <font-awesome-icon :icon="['fa', 'exclamation']" />
               <small class="pl-3">{{ e[0] }}</small>
             </div>
           </div>
           <div class="form-group pt-3">
             <button type="submit" class="btn btn-primary">Войти</button>
           </div>
         </form>
         <div class="col-12 d-block d-md-none text-center">
           <span>Забыли пароль?</span>
           <router-link to="/password-reset" class="border-bottom">
            Восстановить
           </router-link>
         </div>
       </div>

       <div class="col-md-6 px-md-3">
         <div class="font-weight-light pt-3 d-none d-md-block">
           <h5>Забыли пароль?</h5>
         </div>
         <div class="d-none d-md-block">
           <p>
             Для восстановления пароля личного кабинета перейдите по ссылке:
             <router-link to="/password-reset" class="border-bottom">
              Восстановить пароль
             </router-link>
           </p>
         </div>

         <div class="pt-5 d-block d-md-none border-bottom"></div>

         <div class="pt-5 pt-md-3">
           <div class="font-weight-light">
             <h5>Служба поддержки</h5>
           </div>
           <div>
              Тел (бесплатный):
              <a class="border-bottom font-weight-bold" href="tel:88007750808">
                8 (800) 775-08-08</a>
           </div>
<!--           <div class="">-->
<!--             Тел (городской):-->
<!--             <a class="border-bottom font-weight-bold" href="tel:+78617752808">-->
<!--               + 7 (861) 775-28-08</a>-->
<!--           </div>-->
           <div class="row">
             <div class="col-10 col-lg-9 pr-0">
               Тел (мегафон):
               <a class="border-bottom font-weight-bold" href="tel:+79687750808">
                 + 7 (968) 775-08-08
               </a>
             </div>
             <div class="col-1 px-0 px-md-2">
               <font-awesome-icon :icon="['fab', 'whatsapp']" />
             </div>
             <div class="col-1 px-0 px-lg-0">
               <font-awesome-icon :icon="['fab', 'telegram']" />
             </div>
           </div>
         </div>

       </div>
     </div>
   </div>

   <div class="col-12 d-block d-md-none border-bottom"></div>

   <div class="login-wrapper mx-auto py-5 mt-sm-5 pt-lg-4 p-sm-4">
     <v-payment-create-form />
   </div>
   <v-footer />
 </div>

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { TheMask } from 'vue-the-mask';
import VPaymentCreateForm from '../../components/forms/v-payment-create-form.vue';
import VFooter from '../../components/layouts/v-footer.vue';

export default {
  name: 'login-page',
  components: { VFooter, VPaymentCreateForm },
  data() {
    return {
      loginInputs: {
        username: '',
        password: '',
      },
      show: false,
    };
  },
  computed: {
    ...mapState('auth', ['authenticating', 'error']),
    ...TheMask,
    ...mapGetters('auth', ['isAuthenticated']),
  },
  methods: {
    ...mapActions('user', ['getUserDetail']),
    login() {
      this.$store.dispatch('auth/login', this.loginInputs)
        .then(() => this.getUserDetail())
        .then(() => this.$router.push({ name: 'dashboard' }));
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$router.push({ name: 'dashboard' });
    }
  },
};
</script>
